<template>
  <div>
    <!-- 公用底部 -->
    <div :class="footer_red ? 'footer_red' : 'footer'">
      <div class="wrap">
        <div class="ftnav">
          <h3>快速链接</h3>
          <ul>
            <li>
              <a href="/" style="margin-right: 32px">首页</a>
            </li>
            <li v-for="(item, index) in treeList.slice(0, 8)" :key="index">
              <a :hre="item.pagetpl" @click="updateProductUrl(item)">{{
                item.name
              }}</a>
            </li>
          </ul>
          <dl class="select">
            <dt class="" @click="clickcmsLinkList1()">
              <img src="images/xian.jpg" alt="" /><span>政府部门网站相关连接</span><img src="images/xian.jpg" alt="" />
            </dt>
            <dd v-show="LinkList1">
              <a v-for="item in cmsLinkList1" :key="item.id" :href="item.url" target="_blank">{{ item.name }}</a>
            </dd>
          </dl>
        </div>
        <div class="lx">
          <h3>快速链接</h3>
          <p>地址：北京市东城区建国门街道建国门南大街7号荷华明城大厦D座7层</p>
          <p>邮编：100005</p>
          <p>网址：www.ccaa.org.cn</p>
          <dl class="select">
            <dt @click="clickcmsLinkList2()">
              <img src="images/xian.jpg" alt="" /><span>常务理事单位连接</span><img src="images/xian.jpg" alt="" />
            </dt>
            <dd v-if="LinkList2">
              <a v-for="item in cmsLinkList2" :key="item.id" :href="item.url" target="_blank">{{ item.name }}</a>
            </dd>
          </dl>
        </div>
        <div class="ewm">
          <h3>关注我们</h3>
          <div class="wx">
            <p>
              <img :src="cmsConfigListQueryPage.weixinSub[0].fileUrl" alt="" />
              <span>微信订阅号</span>
            </p>
            <p>
              <img :src="cmsConfigListQueryPage.weixinService[0].fileUrl" alt="" />
              <span>微信服务号</span>
            </p>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="bottoms">
        <div class="wrap">
          <p>
            {{ cmsConfigListQueryPage.copyrigh
            }}<a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">{{
              cmsConfigListQueryPage.policeNumber }}</a>
            <a href="https://beian.miit.gov.cn/" target="_blank">{{
              cmsConfigListQueryPage.icpCode
            }}</a>
          </p>
          <a @click="wzdt" class="tt">网站地图</a>
          <a @click="yszc" class="tt">隐私政策</a>
          <div class="clear"></div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import bus from '@/assets/js/bus.js'
import { cmsLinkListQuery, cmsConfigListQueryPage } from '@/api/footer.js'
import { cmsChannelTreeList } from '@/api/nav'
export default {
  data () {
    return {
      cmsLinkList1: [],
      LinkList1: false,
      cmsLinkList2: [],
      LinkList2: false,
      cmsConfigListQueryPage: {},
      treeList: [],
      footer_red: false
    }
  },
  created () {
    this.getCmsLinkList()
    this.getCmsConfigListQueryPage()
    this.getnavList()

  },
  mounted () {
    bus.$on('navkey', (res) => {
      var _this = this
      if (res.id == 140 || res.parentId == 140 || res.parentId == 155 || res.id == 155) {
        _this.footer_red = true
      } else {
        _this.footer_red = false
      }
    })
  },

  methods: {
    yszc () {
      this.$router.push({ path: '/hydt' })
    },
    wzdt () {
      this.$router.push({ path: '/fwdh' })
    },
    async getCmsLinkList () {
      var _this = this
      _this.cmsLinkList1 = []
      _this.cmsLinkList2 = []
      cmsLinkListQuery().then((res) => {
        var data = res.data
        data.forEach((item) => {
          if (item.linkType == 1) {
            this.cmsLinkList1.push(item)
          } else if (item.linkType == 2) {
            this.cmsLinkList2.push(item)
          }
        })
      })
    },
    async getCmsConfigListQueryPage () {
      var _this = this
      cmsConfigListQueryPage().then((res) => {
        _this.cmsConfigListQueryPage = res.data[0]
      })
    },
    async getnavList () {
      var _this = this

      cmsChannelTreeList()
        .then((res) => {

          if (res.code == 0) {
            _this.treeList = res.data
          }
        })
        .catch((res) => { })
    },
    updateProductUrl (item) {

      this.$router.push({ path: item.pagetpl })


    },
    clickcmsLinkList1 () {
      var _this = this
      _this.LinkList1 = !_this.LinkList1
    },
    clickcmsLinkList2 () {
      var _this = this
      _this.LinkList2 = !_this.LinkList2
    },
  },
}
</script>

<style lang="scss" scoped>
/* 公用底部   红色 */
.footer_red {
  padding: 70px 0 0 0;
  background: url('~@/assets/images/footer/foot-red-bg.jpg') no-repeat center;

  .ftnav {
    width: 380px;
    float: left;
    margin: 0 65px 0 0;

    h3 {
      padding-bottom: 20px;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
    }

    ul {
      overflow: hidden;

      li {
        margin: 0 50px 10px 0;
        float: left;
        display: block;

        a {
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }

  .lx {
    width: 380px;
    float: left;

    h3 {
      padding-bottom: 20px;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
    }

    p {
      padding-bottom: 10px;
      font-size: 16px;
      color: #fff;
    }
  }

  .ewm {
    padding-left: 70px;
    border-left: 1px solid #ff4832;
    float: right;

    h3 {
      padding: 0 0 20px 30px;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
    }

    .wx {
      overflow: hidden;

      p {
        margin-left: 30px;
        float: left;

        img {
          display: block;
        }

        span {
          text-align: center;
          padding: 15px 0 4px 0;
          color: #fff;
          display: block;
        }
      }
    }
  }

  .select {
    width: 380px;
    margin-top: 15px;
    position: relative;

    dt {
      width: 340px;
      padding: 0 20px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      display: block;
      background: #9c1a00 url('~@/assets/images/footer/jt-red.png') no-repeat 345px center;
      cursor: pointer;
      overflow: hidden;
      position: relative;
      z-index: 99;

      img {
        margin: 22px 0;
        display: block;
        float: left;
      }

      span {
        padding: 0 10px;
        display: block;
        float: left;
      }
    }

    dd {
      width: 380px;
      height: 120px;
      padding: 5px 0;
      position: absolute;
      left: 0;
      top: 46px;
      background: #9c1a00;
      ;
      /* display: none; */
      overflow: auto;

      a {
        line-height: 40px;
        padding: 0 20px;
        font-size: 16px;
        color: #ccc;
        display: block;
        background: #9c1a00 url('~@/assets/images/footer/jt2-red.png') no-repeat 350px center;
      }
    }

    dd::-webkit-scrollbar {
      width: 15px;
    }

    dd::-webkit-scrollbar-track {
      background: url('~@/assets/images/footer/dian.jpg') repeat-y center;
    }

    dd::-webkit-scrollbar-thumb {
      background: url('~@/assets/images/footer/dianh.jpg') repeat-y center;
    }

    dd::-webkit-scrollbar-thumb:window-inactive {
      background: url('~@/assets/images/footer/dianh.jpg') repeat-y center;
    }

    dd::-webkit-scrollbar-thumb:vertical:hover {
      background: url('~@/assets/images/footer/dianh.jpg') repeat-y center;
    }
  }

  .bottoms {
    margin-top: 70px;
    border-top: 1px solid #ff4832;

    p {
      line-height: 65px;
      font-size: 16px;
      color: #fff;
      float: left;

      a {
        font-size: 16px;
        color: #fff;
      }
    }

    .tt {
      line-height: 65px;
      margin-left: 25px;
      font-size: 16px;
      color: #fff;
      display: block;
      float: right;
    }
  }
}



/* 公用底部 */
.footer {
  padding: 70px 0 0 0;
  background: url('~@/assets/images/footer/footbg.jpg') no-repeat center;

  .ftnav {
    width: 380px;
    float: left;
    margin: 0 65px 0 0;

    h3 {
      padding-bottom: 20px;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
    }

    ul {
      overflow: hidden;

      li {
        margin: 0 50px 10px 0;
        float: left;
        display: block;

        a {
          font-size: 16px;
          color: #fff;
        }
      }
    }
  }

  .lx {
    width: 380px;
    float: left;

    h3 {
      padding-bottom: 20px;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
    }

    p {
      padding-bottom: 10px;
      font-size: 16px;
      color: #fff;
    }
  }

  .ewm {
    padding-left: 70px;
    border-left: 1px solid #6589c4;
    float: right;

    h3 {
      padding: 0 0 20px 30px;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
    }

    .wx {
      overflow: hidden;

      p {
        margin-left: 30px;
        float: left;

        img {
          display: block;
        }

        span {
          text-align: center;
          padding: 15px 0 4px 0;
          color: #fff;
          display: block;
        }
      }
    }
  }

  .select {
    width: 380px;
    margin-top: 15px;
    position: relative;

    dt {
      width: 340px;
      padding: 0 20px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 16px;
      color: #fff;
      display: block;
      background: #164186 url('~@/assets/images/footer/jt.jpg') no-repeat 345px center;
      cursor: pointer;
      overflow: hidden;
      position: relative;
      z-index: 99;

      img {
        margin: 22px 0;
        display: block;
        float: left;
      }

      span {
        padding: 0 10px;
        display: block;
        float: left;
      }
    }

    dd {
      width: 380px;
      height: 120px;
      padding: 5px 0;
      position: absolute;
      left: 0;
      top: 46px;
      background: #164186;
      /* display: none; */
      overflow: auto;

      a {
        line-height: 40px;
        padding: 0 20px;
        font-size: 16px;
        color: #ccc;
        display: block;
        background: url('~@/assets/images/footer/jt2.jpg') no-repeat 350px center;
      }
    }

    dd::-webkit-scrollbar {
      width: 15px;
    }

    dd::-webkit-scrollbar-track {
      background: url('~@/assets/images/footer/dian.jpg') repeat-y center;
    }

    dd::-webkit-scrollbar-thumb {
      background: url('~@/assets/images/footer/dianh.jpg') repeat-y center;
    }

    dd::-webkit-scrollbar-thumb:window-inactive {
      background: url('~@/assets/images/footer/dianh.jpg') repeat-y center;
    }

    dd::-webkit-scrollbar-thumb:vertical:hover {
      background: url('~@/assets/images/footer/dianh.jpg') repeat-y center;
    }
  }

  .bottoms {
    margin-top: 70px;
    border-top: 1px solid #6589c4;

    p {
      line-height: 65px;
      font-size: 16px;
      color: #fff;
      float: left;

      a {
        font-size: 16px;
        color: #fff;
      }
    }

    .tt {
      line-height: 65px;
      margin-left: 25px;
      font-size: 16px;
      color: #fff;
      display: block;
      float: right;
    }
  }
}
</style>